export const TRADE_PAGE_URL = "/trade";
export const TRADE_DETAIL_PAGE_URL = "/trade/";
export const INVEST_PAGE_URL = "/invest";
export const HOMEPAGE_URL = INVEST_PAGE_URL;
export const LIVE_INVEST_PAGE_URL = `${INVEST_PAGE_URL}/live`;
export const FUNDED_INVEST_PAGE_URL = `${INVEST_PAGE_URL}/funded`;
export const ECF_ORDER_DETAILS_PAGE_URL = "/order-details";
export const APRIME_ORDER_DETAILS_PAGE_URL = "/order-details";
export const ACCOUNT_CHANGE_INVESTOR_TYPE_URL = "/account/change-investor-type";
export const FRACKFRACK_INVEST_PAGE_URL = "/frackfrack";
export const FRACKFRACK_SIGNUP_PAGE_URL = "/signup?ref=frackfrack";
